import GjwListPage from './src/GjwListPage.vue'

GjwListPage.install = function(Vue) {
  Vue.component(GjwListPage.name, GjwListPage)
}

export default GjwListPage
